function n(r) {
  const e = [];
  for (const t of r)
    e.push(...t);
  return e;
}
function o(r) {
  return r.slice().reverse();
}
export {
  n as flatten2DArray,
  o as reverseArray
};
//# sourceMappingURL=7PRQYBBV.js.map
